export default __webpack_public_path__ + "static/media/path.8fd6331e.png";